<h2 mat-dialog-title>{{ translations.title }}</h2>

<mat-dialog-content>
  <div class="note" i18n="@@delivery-overlay.ddsdialog.text">
    Select an option for adding a due diligence statement:
  </div>
  <div class="flex-column buttons-container">
    <app-button (pressed)="onClickGenerateEudrReport()">
      {{ translations.buttons.createNew }}
      <mat-icon icon-right [tp]="translations.buttons.createNewHint" [tpIsLazy]="true">
        help
      </mat-icon>
    </app-button>
    <app-button (pressed)="onAddExistingDdsIdentifier()">
      {{ translations.buttons.addExisting }}
      <mat-icon icon-right [tp]="translations.buttons.addExistingHint" [tpIsLazy]="true">
        help
      </mat-icon>
    </app-button>
    <app-button (pressed)="onAddExistingReferenceNumber()">
      {{ translations.buttons.addExistingReferenceNumber }}
      <mat-icon
        icon-right
        [tp]="translations.buttons.addExistingReferenceNumberHint"
        [tpIsLazy]="true"
      >
        help
      </mat-icon>
    </app-button>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <app-button-group>
    <app-button (pressed)="onClose()" type="ghost" i18n="@@shared.cancel">Cancel</app-button>
  </app-button-group>
</mat-dialog-actions>
